var map = {
	"./arrow-back-to-album.svg": 41063,
	"./arrow-left-gold.svg": 75110,
	"./arrow-right-gold.svg": 78505,
	"./arrow-yellow.png": 6711,
	"./badge-user-league.png": 43404,
	"./badge-user-level.svg": 35942,
	"./blue-corner.svg": 49162,
	"./booster.png": 54315,
	"./card.png": 76937,
	"./cards.png": 77526,
	"./cardstack-3.png": 35857,
	"./chest-bronze.png": 48427,
	"./chest-gold.png": 89545,
	"./chest-silver.png": 59280,
	"./coin.png": 42356,
	"./coin1.png": 88343,
	"./coin1_big.png": 26164,
	"./coin2.png": 99612,
	"./coin2_big.png": 20651,
	"./crown.png": 93978,
	"./crown2.png": 88082,
	"./crown2_big.png": 20677,
	"./crown3.png": 53435,
	"./crown4.png": 43492,
	"./crown6-big.png": 21707,
	"./crown6.png": 78966,
	"./crown7.png": 57055,
	"./dailylogin-card.png": 88842,
	"./deco-gem-blue-left.png": 17839,
	"./deco-gem-blue-right.png": 58496,
	"./display-background.svg": 82511,
	"./earning-shield-bg.png": 89999,
	"./elixir.png": 19378,
	"./facebook.png": 7183,
	"./fb-logo-shadow.png": 36726,
	"./glow.png": 68152,
	"./golden-corner-small.svg": 32625,
	"./golden-corner.png": 14660,
	"./goldstack_L.png": 59196,
	"./input-field-checkmark.svg": 65431,
	"./levelup-badge.png": 75256,
	"./lock-close-blank.png": 85840,
	"./lock-close.png": 33677,
	"./lock-gold.png": 759,
	"./lock-open.png": 62041,
	"./loyalty-bonus.png": 80139,
	"./loyalty.png": 5065,
	"./pag-arrow-last.svg": 34449,
	"./pag-arrow-next.svg": 75206,
	"./reward-display.svg": 82248,
	"./ritter-gold.png": 45134,
	"./sparkles.png": 8914,
	"./three-cards.png": 68161,
	"./three-coins.png": 94938,
	"./three-crowns.png": 12674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30482;